/**
 * 'Autocomplete confluence macro' dropdown appears when you press a '{' character in the editor.
 */
import AJS from 'ajs_DO_NOT_USE';
import window from 'window-or-global';
import { trigger } from '@confluence-classic/confluence-event_DO_NOT_USE';
import { getRte } from '../../facades/editor';
// TODO: remove jquery from here and from webpack config once CONFDEV-52616 is done.
// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';
import MacroUtils from '../utils/macro-utils';
import MacroBrowser from '../utils/macro-browser';

/**
 * TODO:
 * - remove Confluence global
 *
 * @param {object} ed   Tinymce instance
 */
function AutoCompleteSettingsMacro(ed) {
	function toggleSpinner(visible) {
		$('#autocomplete-dropdown .top-menu-item').spin(visible);
	}

	function retryLoadMacros() {
		//TODO: remove global object
		AJS.MacroBrowser.reset();
		AJS.MacroBrowser.preLoadMacro();
	}

	function dropdownSelectionMade(autoCompleteControl, options) {
		const macroMetadata = options.presetMacroMetadata;

		autoCompleteControl.replaceWithSelectedSearchText();

		if (!macroMetadata) {
			MacroBrowser.macroBrowserToolbarButtonClicked(options);
		} else {
			// only open the macro browser if there are required parameters
			if (
				AJS.MacroBrowser.hasRequiredParameters(macroMetadata) ||
				!!macroMetadata.alwaysShowConfig
			) {
				MacroBrowser.macroBrowserToolbarButtonClicked(options);
			} else {
				getRte().BookmarkManager.storeBookmark();

				MacroUtils.insertMacro({
					contentId: AJS.Meta.get('content-id') || '0',
					macro: {
						name: macroMetadata.macroName,
						body: '',
					},
				});
			}
		}
	}

	function makeMacroDropdownItem(summary) {
		if (summary.hidden && !AJS.MacroBrowser.isHiddenMacroShown(summary)) {
			return null; // macros like {viewfile} hidden from the browser should be hidden from the dropdown
		}

		const item = {
			className: `autocomplete-macro-${summary.macroName}`,
			callback(autoCompleteControl) {
				dropdownSelectionMade(autoCompleteControl, {
					ignoreEditorSelection: true, // the selected text will be the search term, ignore it
					presetMacroMetadata: summary,
				});
			},
		};

		if (summary.icon) {
			item.name = summary.title;
			item.href = '#';
			item.icon =
				(summary.icon.relative ? AJS.params.staticResourceUrlPrefix : '') + summary.icon.location;
		} else {
			item.html = AJS.Editor.Autocompleter.Util.dropdownLink(summary.title);
		}

		return item;
	}

	// Macro settings.
	AJS.Editor.Autocompleter.Settings['{'] = {
		ch: '{',
		cache: false,
		endChars: ['}', ':', '{'],
		dropDownClassName: 'autocomplete-macros',
		dropDownDelay: 0, // No delay needed because there is no AJAX request involved
		selectFirstItem: true,

		getHeaderText() {
			return ed.translate('editor.autocomplete.macros.header.text');
		},

		getAdditionalLinks() {
			return [
				{
					className: 'dropdown-insert-macro',
					html: AJS.Editor.Autocompleter.Util.dropdownLink(
						ed.translate('editor.autocomplete.macros.dialog.browse'),
						'dropdown-prevent-highlight',
						'editor-icon',
					),
					callback(autoCompleteControl) {
						const searchText = autoCompleteControl.text();
						dropdownSelectionMade(autoCompleteControl, { searchText });
					},
				},
			];
		},

		getDataAndRunCallback(autoCompleteControl, val, callback) {
			const promiseMetaData = AJS.MacroBrowser.getMetadataPromise();
			const self = this;
			const args = arguments;

			function populateEmpty(metadataList) {
				const dropdownItems = [];
				$('#macro-insert-list li').each((i, li) => {
					const $li = $(li);
					const macroMetaData = metadataList.find((macroMetaData) => {
						return macroMetaData.macroName === $li.attr('data-macro-name');
					});

					if (macroMetaData) {
						const dropdownItem = makeMacroDropdownItem(macroMetaData);
						dropdownItem && dropdownItems.push(dropdownItem);
					}
				});
				return dropdownItems;
			}

			function populateWithValue(value) {
				const dropdownItems = [];
				const summaries = AJS.MacroBrowser.searchSummaries(value, {
					keywordsField: 'keywordsNoDesc',
				});

				for (let i = 0, ii = summaries.length; i < ii; i++) {
					const dropdownItem = makeMacroDropdownItem(summaries[i]);
					if (dropdownItem && dropdownItems.push(dropdownItem) == autoCompleteControl.maxResults) {
						break;
					}
				}
				return dropdownItems;
			}

			/**
			 * Will be called when macroBrowser has metadata
			 */
			function populate() {
				let dropdownItems;
				if (!val) {
					dropdownItems = populateEmpty(AJS.MacroBrowser.metadataList);
				} else {
					dropdownItems = populateWithValue(val);
				}

				toggleSpinner(false);

				callback([dropdownItems], val);
			}

			function retryLoading(e) {
				e.preventDefault();
				e.stopPropagation();

				trigger('analytics', { name: 'autocomplete-macrobrowser.load-retry' });

				// retry to fetch the data
				retryLoadMacros();

				// call getDataAndRunCallback again with same arguments
				self.getDataAndRunCallback.apply(self, args);
			}

			// making sure it is only called once
			if (!self.alreadyBinded) {
				self.alreadyBinded = true;

				promiseMetaData.always(() => {
					populate();
					self.alreadyBinded = false; // if its called again we need to re-attach handlers again to the new promise
				});

				promiseMetaData.fail(() => {
					trigger('analytics', {
						name: 'autocomplete-macrobrowser.fail-to-load',
					});

					AJS.messages.warning('#autocomplete-dropdown ol:nth(1)', {
						title: ed.translate('editor.autocomplete.macros.error.load.header'),
						body: `<p><a id='macro-retry-link' href='#'>${ed.translate(
							'editor.autocomplete.macros.error.load.retrylink',
						)}</a></p>`,
					});

					$('#macro-retry-link').click(retryLoading);

					// this is where the error message gets populated to
					$('#autocomplete-dropdown ol').eq(1).show();
				});
			}

			if (promiseMetaData.state() === 'pending') {
				callback([], val); //
				toggleSpinner(true);
			}
		},

		update() {
			throw new Error('All items in the Macro Autocomplete dropdown must have a callback function');
		},
	};
}

function plugger() {
	return {
		init(ed) {
			AutoCompleteSettingsMacro(ed);
		},

		getInfo() {
			return {
				longname: 'Auto Complete Macro',
				author: 'Atlassian',
				authorurl: 'http://www.atlassian.com',
				version: `${window.tinymce.majorVersion}.${window.tinymce.minorVersion}`,
			};
		},
	};
}

export function autocompleteMacro() {
	console.log('Finished loading Autocomplete base, Macro browser, JIM, Jira chart plugin');
	window.tinymce.create('tinymce.plugins.AutoCompleteMacro', plugger());
	window.tinymce.PluginManager.add('autocompletemacro', window.tinymce.plugins.AutoCompleteMacro);
}

export function autocompleteMacroWRM() {
	return [
		'wr!confluence.extra.jira:macro-browser-resources',
		'wr!confluence.extra.jira:dialogsJs-for-conf-frontend',
		'wr!confluence.extra.jira:jirachart-macro',
		// Additional resource from confluence.extra.jira is loaded in placeholder/text-placeholders-jira.js
	];
}
